import NavItem from "@/domain/entities/navbar/NavItem";
import { NavItem as NavItemMailvista } from "@cs_teamwaydev/mailvista-sdk_react";
import menuItemInfoMapper from "./menuItemInfoMapper";

const navItemMapper = (navItem: NavItemMailvista): NavItem =>
    new NavItem({
        id: navItem.id,
        menuInfo: navItem.menuInfo
            ? menuItemInfoMapper(navItem.menuInfo)
            : undefined,
        itemCount: navItem.itemCount,
        isFavorite: navItem.isFavorite,
    });

export default navItemMapper;
